import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import {
  SIGNOUT_USER_SUCCESS
} from '../constants/AppConstants';

import Auth from './auth';
import Reducer from './reducers';
import AppView from './appView';
import ReactNotification from './reactNotification';
import Notification from './notification';
import Seller from './seller';

const appReducers = combineReducers({
  routing: routerReducer,
  auth: Auth,
  reducer: Reducer,
  appView: AppView,
  reactNotification: ReactNotification,
  notification: Notification,
  seller: Seller,
});

const reducers = ( state, action ) => {
  if ( action.type === SIGNOUT_USER_SUCCESS ) {
    state = undefined;
  }

  return appReducers(state, action)
}

export default reducers;
